import React from "react";
import styled from "styled-components";

import { Divider, Header, PageWrapper } from "src/shared/components";
import {} from "src/shared/utils/validation";

import FlockGroup from "./components/FlockGroup";
import ConnectionHistory from "./ConnectionHistory";
import Profile from "./Profile";
import Socials from "./Socials";

const Networking = () => {
  return (
    <>
      <Header
        title="Networking"
        subtitle="A quick way to connect with new people at the event!"
      />

      <PageWrapper>
        <ContentWrapper>
          <Profile />
          <Divider />
          <Socials />
          <Divider />
          <FlockGroup />
          <Divider />
          <ConnectionHistory />
        </ContentWrapper>
      </PageWrapper>
    </>
  );
};

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  max-width: 600px;
`;

export default Networking;
